import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { heroData } from "../data/mockData";
import { motion, AnimatePresence } from "framer-motion";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const heroImages = ["/hero1.jpg", "/hero2.jpg", "/hero3.jpg"];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-overlay" />
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          className="hero-bg"
          style={{
            backgroundImage: `url('${heroImages[currentSlide]}')`,
          }}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
        />
      </AnimatePresence>
      <div className="hero-content">
        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {heroData.subtitle}
        </motion.p>
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          {heroData.title}
        </motion.h1>
        <motion.div
          className="hero-line"
          initial={{ width: 0 }}
          animate={{ width: 60 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        />
        <motion.p
          className="hero-description"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          {heroData.description}
        </motion.p>
        <motion.div
          className="hero-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.9 }}
        >
          <button className="btn-primary" onClick={() => scrollTo("#contact")}>
            {heroData.ctaText}
            <ArrowRight size={18} />
          </button>
        </motion.div>
      </div>
      <div className="hero-scroll-indicator">
        <div className="scroll-line" />
      </div>
    </section>
  );
};

export default HeroSection;
